import { render, staticRenderFns } from "./FeaturedCarouselPlaceholder.vue?vue&type=template&id=4a918927&"
import script from "./FeaturedCarouselPlaceholder.vue?vue&type=script&lang=js&"
export * from "./FeaturedCarouselPlaceholder.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedCarouselPlaceholder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports